export default __webpack_public_path__ + "static/media/ductBank1.f5c06e86.jpg";